import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";

import { renderContentfulComponent } from "@lululemon/cosy-contentful-renderer";
import { baseRenderContentType, RichText } from "@lululemon/ui-library";

import { createEncodedKey } from "../../utils/helpers";
import VisualStoryGridItem from "./visual-story-grid-item";

import styles from "./visual-story-grid.module.scss";

export const FeatureGrid = ({ featureGrid }) => (
  <div className={cs("lll-grid", styles.featureGridWrapper)}>
    {featureGrid.map((item, index) => {
      let visualStoryGridItemHeading = null;
      let visualStoryGridItemSubContent = null;
      let imgSrc = null;
      let mobileImgSrc = null;
      let imgAlt = null;

      // support new webVisualStoryGridItem content-type and existing webPromoCard content-type
      if (item?.sys?.contentType?.sys?.id === "webVisualStoryGridItem") {
        const { title, subContent, responsiveImage } = item?.fields || {};

        const {
          imageUrl,
          mobileImageUrl,
          description: imageDescription
        } = responsiveImage?.fields || {};

        visualStoryGridItemHeading = title;
        visualStoryGridItemSubContent = (
          <RichText
            body={subContent}
            customEntryRenderer={renderContentfulComponent}
            options={{ renderContentType: baseRenderContentType }}
          />
        );
        imgSrc = imageUrl;
        mobileImgSrc = mobileImageUrl;
        imgAlt = imageDescription;
      } else {
        const { title, description, desktopMedia, mobileMedia } =
          item?.fields || {};

        const {
          imageUrl: desktopImageUrl,
          imageDescription: desktopImageDescription
        } = desktopMedia?.fields || {};

        const {
          imageUrl: mobileImageUrl,
          imageDescription: mobileImageDescription
        } = mobileMedia?.fields || {};

        visualStoryGridItemHeading = title;
        visualStoryGridItemSubContent = description;
        imgSrc = desktopImageUrl;
        mobileImgSrc = mobileImageUrl;
        imgAlt = desktopImageDescription || mobileImageDescription;
      }

      return (
        <VisualStoryGridItem
          heading={visualStoryGridItemHeading}
          subContent={visualStoryGridItemSubContent}
          imageProps={{ src: imgSrc, mobileSrc: mobileImgSrc, alt: imgAlt }}
          key={createEncodedKey(`${visualStoryGridItemHeading}${index}`)}
        />
      );
    })}
  </div>
);

FeatureGrid.propTypes = {
  featureGrid: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.oneOfType([
        // visualStoryGridItem
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          subContent: PropTypes.node,
          responsiveImage: PropTypes.shape({
            fields: PropTypes.shape({
              imageUrl: PropTypes.string,
              mobileImageUrl: PropTypes.string,
              description: PropTypes.string
            })
          })
        }),
        // promoCard
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string,
          aspectRatio: PropTypes.string.isRequired,
          desktopMedia: PropTypes.shape({
            fields: PropTypes.shape({
              imageUrl: PropTypes.string.isRequired,
              imageDescription: PropTypes.string.isRequired
            })
          }),
          mobileMedia: PropTypes.shape({
            fields: PropTypes.shape({
              imageUrl: PropTypes.string.isRequired,
              imageDescription: PropTypes.string.isRequired
            })
          })
        })
      ])
    })
  ).isRequired
};
